import { faCapsules } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import dayjs from 'dayjs'
import React, { useRef, useState } from 'react'
import usePatGeneralMeds from '../../hooks/usePatGeneralMeds'
import '../Styling/MobileMedications.css'

const MobGeneralMedicationsCarousel = () => {
  const { generalMeds } = usePatGeneralMeds()
  const [activeIndex, setActiveIndex] = useState(0)
  const listRef = useRef(null)

  const formatMedicationName = (name) => {
    if (!name) return ''
    return name
      .split(' ')
      .map((word) =>
        word.length <= 2 ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(' ')
  }

  const handleScroll = (e) => {
    const container = e.target
    const itemWidth = container.children[0]?.offsetWidth + 16 || 0 // width + gap
    const scrollPosition = container.scrollLeft
    const newIndex = Math.round(scrollPosition / itemWidth)
    if (newIndex !== activeIndex) {
      setActiveIndex(newIndex)
    }
  }

  return (
    <div>
      <div className='chronic-meds-container'>
        <div className='mobile-chronic-meds'>
          <div className='chronic-meds-list' ref={listRef} onScroll={handleScroll}>
            {generalMeds.map((med, index) => (
              <div key={index} className={`med-card general-med-card ${index === activeIndex ? 'active' : ''}`}>
                <div className='med-icon'>
                  <FontAwesomeIcon icon={faCapsules} />
                </div>
                <div className='med-info'>
                  <div className='med-header'>
                    <h3>{formatMedicationName(med.med.name)}</h3>
                  </div>
                  <p className='frequency'>Started: {dayjs(med.startDate).format('DD MMM YYYY')}</p>
                  <div className='refill-info'>
                    <div className='days-left'>
                      <div className='label'>Status:</div>
                      <span className='value'>
                        {med.endDate ? `Ended: ${dayjs(med.endDate).format('DD MMM YYYY')}` : 'Current'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {generalMeds.length === 0 && (
              <div className='empty-med-card general-empty-card'>
                <FontAwesomeIcon icon={faCapsules} size='2x' />
                <p>No general medications found</p>
                <p className='empty-subtitle'>Your general medications will appear here</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobGeneralMedicationsCarousel
